import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ApplicationBundle } from '@/lib/applicationBundles';
import type { FarmResponse } from '@/types/api';

/** The farm's application bundles (settings.application_bundles); none until configured. Shares the
 *  settings page's farm query. */
export function useApplicationBundles(farmId: string | null | undefined): ApplicationBundle[] {
  const { data } = useQuery({
    queryKey: ['farm', farmId],
    queryFn: () => api.get<{ data: FarmResponse }>(`/api/v1/farms/${farmId}`),
    enabled: !!farmId,
    staleTime: 5 * 60 * 1000,
  });
  const raw = data?.data?.settings?.application_bundles;
  // Anything hand-edited that isn't a bundle of product items is ignored here (the API refuses it too).
  return Array.isArray(raw)
    ? (raw as ApplicationBundle[]).filter((b) => b && typeof b.id === 'string' && Array.isArray(b.items) && b.items.every((i) => i && typeof i === 'object'))
    : [];
}
